<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <b-overlay
            variant="white"
            :show="showLoading"
            spinner-variant="primary"
            blur="0"
            opacity=".75"
            rounded="sm"
        >
          <div class="p-1">
            <form class="" @submit.prevent="submitForm">
                <div class="row">
                  <div class="form-group col-12 col-md-3">
                    <label for="phone24">Nombre:</label>
                    <b-form-input v-model="responsible.name" autocomplete="off"/>
                    <span v-if="validation_responsible.name" class="text-danger">
                                        {{ validation_responsible.name }}
                                      </span>
                  </div>
                  <div class="form-group col-12 col-md-3">
                    <label for="phone24">Observación:</label>
                    <b-form-input v-model="responsible.observations" autocomplete="off"/>
                  </div>
                  <div class="form-group col-12 col-md-3">
                    <label for="phone24">Email:</label>
                    <b-form-input v-model="responsible.email" autocomplete="off"/>
                    <span v-if="validation_responsible.email" class="text-danger">
                                        {{ validation_responsible.email }}
                                      </span>
                  </div>
                  <div class="form-group col-12 col-md-3">
                    <label for="phone24">Teléfono:</label>
                    <b-form-input v-model="responsible.phone" autocomplete="off"/>
                  </div>
                </div>
              <div class="row">
                <button type="submit" class="btn btn-primary col-12 col-md-1 ml-1 mt-2">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import {BCard, BCol, BOverlay, BRow, BFormInput, BFormGroup, BFormCheckbox} from 'bootstrap-vue'
import {mapState} from "vuex"
import {GEI_AUXILIAR2_RESPONSIBLES_LIST} from "@/router/web/constants"
import {createHelpers} from "vuex-map-fields"

import helper from "@/resources/helpers/helpers"

const {mapFields} = createHelpers({
  getterType: 'responsibles/getField',
  mutationType: 'responsibles/updateField',
})

export default {
  name: "FormView",
  components: {
    BCol,
    BRow,
    BCard,
    BFormInput,
    BOverlay,
  },
  data() {
    return {
      edit: false,
      showLoading: false,
    }
  },
  computed: {
    ...mapState('auxiliaries2Responsibles', ['validation_responsible']),
    ...mapFields({
      responsible: 'responsible',
    }),
  },
  created() {

    this.$store.commit('auxiliaries2Responsibles/RESET_STATE')
    this.$store.commit('auxiliaries2Responsibles/CLEAR_VALIDATION')

    if (this.$route.params.id) {
      this.edit = true
      this.getResponsibles()
    } else {
      this.edit = false
    }
    this.$root.$refs.auxiliaries2ResponsibleForm = this
  },
  methods: {
    getResponsibles() {
      this.showLoading = true
      this.$store.dispatch('responsibles/findResponsibles', {
        id: this.$route.params.id ?? this.responsible.id
      })
          .then(response => {
            this.showLoading = false
          })
          .catch(error => {
            this.showLoading = false
          })
    },
    cancel() {
      this.$router.push(GEI_AUXILIAR2_RESPONSIBLES_LIST)
    },
    createAuxiliar() {
      this.$store.dispatch('responsibles/createResponsibles', this.responsible)
          .then(response => {
            helper.showToast('Responsable creado correctamente!', 'CheckIcon', 'success')
            this.$router.replace(GEI_AUXILIAR2_RESPONSIBLES_LIST)
          })
          .catch(error => {
            helper.showToast('Error al crear responsable', 'AlertOctagonIcon', 'danger')
            console.log(error)
          })
    },
    updateAuxiliar() {
      this.$store.dispatch('responsibles/updateResponsibles', this.responsible)
          .then(response => {
            helper.showToast('Responsable editado correctamente!', 'CheckIcon', 'success')
            this.$router.replace(GEI_AUXILIAR2_RESPONSIBLES_LIST)
          })
          .catch(error => {
            helper.showToast('Error al editar responsable', 'AlertOctagonIcon', 'danger')
            console.log(error)
          })
    },
    submitForm() {
      if (this.$route.params.id) {
        this.updateAuxiliar()
      } else {
        this.createAuxiliar()
      }
    },
  },
}
</script>